import { Grid } from '@mui/material';


function Card ({ children, ...props }) {

  return(
    <Grid
      sx={{
        backgroundColor: 'white',
        padding: '2rem',
        borderRadius: 4,
        maxWidth: '32rem',
        ...props.sx
      }}
    >
      {children}
  </Grid>
  )
}

export default Card

